import PropTypes from "prop-types";
import ProfileAvatar from "@/ui/Profile_Avatar";
import Avatar from "@/components/common/Avatar";

const UserProfileCard = ({
  user,
  completionPercentage = 100,
  role = "User",
  className = "",
  participants = [],
}) => (
  <div
    className={`bg-white rounded-lg p-4 mb-4 flex flex-col items-center ${className}`}>
    <ProfileAvatar
      imageUrl={user.avatar}
      badgeNumber={user.badgeCount > 0 ? user.badgeCount : null}
      completionPercentage={completionPercentage}
      size="medium"
      altText={user.name}
      className="mb-4"
    />

    {/* Text Content */}
    <div className="text-center">
      <h3 className="mb-1 text-primary heading-regular">
        {user?.name || "Not Assigned"}
      </h3>
      <p className="font-normal text-lighterGrey text-bold">
        {user?.customRole || role}
      </p>
    </div>

    {/* Optional participants display */}
    {participants.length > 0 && (
      <div className="mt-4 w-full">
        <p className="text-sm text-gray-500 mb-2">Participants:</p>
        <div className="flex flex-wrap">
          {participants.map((participant, index) => (
            <div
              key={participant.id || index}
              className="-ml-1 first:ml-0">
              <Avatar
                src={participant.avatar}
                alt="Participant"
                size={32}
                border
                borderColor="white"
              />
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);

UserProfileCard.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    avatar: PropTypes.string,
    badgeCount: PropTypes.number,
    customRole: PropTypes.string,
  }),
  completionPercentage: PropTypes.number,
  role: PropTypes.string,
  className: PropTypes.string,
  participants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      avatar: PropTypes.string,
    })
  ),
};

export default UserProfileCard;
